// components/ReviewWarningModal.js

import ModalWrapper from "../../Neighborhood/[id]/ModalWrapper";

// import ModalWrapper from "./ModalWrapper.js";

const ReviewWarningModal = ({
  isModalOpen,
  contentLabel,
  customStyles,
  onClickClose,
}) => {
  return (
    <ModalWrapper
      isOpen={isModalOpen}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div
        className="close_icon_select close_personal close_perosnal_dnh"
        onClick={onClickClose}
      >
        <a className="boxclose" id="boxclose"></a>
      </div>
      <p className="rate_err">You cannot rate your own review</p>
    </ModalWrapper>
  );
};

export default ReviewWarningModal;
